import get from 'get-value';
import {commercialWebsocketCommands} from '../../constants/commercialWebsocketCommands';

export const commercialDealer = (state = {
    isLoadingDealer: false,
    dealers: [],
    correlationId: null,
}, action) => {
    switch (action.type) {
        case commercialWebsocketCommands.COMMERCIAL_DEALERS_GET: {
            return Object.assign({}, state, {isLoadingDealer: true});
        }
        case commercialWebsocketCommands.COMMERCIAL_DEALERS_SEND: {
            const dealers = get(action, 'payload.dealers', {default: []});
            return Object.assign({}, state, {
                isLoadingDealer: false,
                dealers,
            });
        }
        case commercialWebsocketCommands.COMMERCIAL_DEALERS_SEND_ERROR: {
            return Object.assign({}, state, {isLoadingDealer: false});
        }
        default:
            return state;
    }
};
